import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { RenderViewComponentType } from '@upright/common/renderer/types';
import {
  LensSelectionStateHandler,
  SerializedLensSelectionStateParams,
} from '@upright/ui/common/upright/core/impact-lenses/selection-hook';
import { useGetRenderViewComponentParamSetter } from '../../context/component-param-setter';

export function useGetLensSelectionStateHandler(
  params: { selectionState: string },
  componentType: RenderViewComponentType,
): LensSelectionStateHandler {
  const lensType = getLensTypeOfRenderViewComponent(componentType);
  const setParams = useGetRenderViewComponentParamSetter(componentType);
  const selectionState = { [lensType]: params.selectionState };
  const setSelectionState = (paramsToSet: Partial<SerializedLensSelectionStateParams>) => {
    setParams(curr => {
      return {
        ...curr,
        selectionState: paramsToSet[lensType] || '',
      };
    });
  };

  return [selectionState, setSelectionState];
}

function getLensTypeOfRenderViewComponent(componentType: RenderViewComponentType) {
  switch (componentType) {
    case RenderViewComponentType.LENS_NET_IMPACT:
      return ImpactLensType.UPRIGHT_NET_IMPACT;
    default:
      throw Error(`Unsupported render view component of type ${componentType}`);
  }
}
